"use client";

// packages/eden-headings/src/components/H5.jsx
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var H5Styled = styled.h5`
  margin: 0;
  font: normal normal 700 calc(14rem / 16) / 1.2 var(--unity-font-family-sans);
`;
var H5 = ({ children, renderAs, ...props }) => /* @__PURE__ */ jsx(H5Styled, { as: renderAs, ...props, children });
H5.displayName = "H5";
var H5_default = H5;
export {
  H5_default as default
};
